import CategoryViewPageModel from './CategoryViewPageModel.js';

export const CATEGORY_PACK_MODEL = 'categoryPack';

// Sous-modèle de la page catégorie: mêmes blocs (le back-office se configure exactement pareil),
// mais la liste ne contient que les produits de type pack, affichés en cartes identiques
// à celles des produits simples (ProductList / ProductListItem) au lieu du slider PackList.
const CategoryPackViewPageModel = {
    ...CategoryViewPageModel,
    name: CATEGORY_PACK_MODEL,
    blocks: [...CategoryViewPageModel.blocks],
};

// Le mode "packs uniquement" se déduit du modèle de la page: aucun bloc CMS n'est requis, donc
// les catégories déjà enregistrées (modèle `category`) ne sont pas concernées et continuent
// d'afficher le slider de packs sous la liste des produits.
export function isCategoryPackPage(page) {
    return (page || {}).model === CATEGORY_PACK_MODEL;
}

export default CategoryPackViewPageModel;
